// extracted by mini-css-extract-plugin
export default {"center":"Spinner_center__FxOY8"};